export default __webpack_public_path__ + "static/media/6.46eecd15.png";